module.exports = __webpack_public_path__ + "img/mistakesText16.f4d5ebb5.png";